export enum DeliveryEquipmentTypes {
    Container = 1,
    TrailerFlatbedOther = 2,
    FacilitySupplies = 3,
}
